import {createSelector} from 'reselect';
import {Map} from 'immutable';

const emptyMap = Map();
//const componentDetailsSelector = state => state.appState.getIn(['uiData', 'dotInspection', 'componentDetails']);

